import { useCallback } from "react";

import { LangCode } from "@/lib/gql/__generated__/graphql";

import { useCampaignEmailTemplates as useEmailTemplates } from "@/components/features/items/edit/_shared/ui/components/main/questions/email-templates/campaign/hooks";

import { useSendTestEmailCreated } from "../../../../../../model/repository/existing/_shared/mutation/test-email";
import { useMarketingCampaignFormModelContext } from "../../../../context";

export const useCampaignEmailTemplates = () => {
	const { viewModel, onSetViewModel, queryData } = useMarketingCampaignFormModelContext();
	const { hotelEmailAddress } = queryData;
	const { mailTemplate } = viewModel;
	const { sendEmail_Created } = useSendTestEmailCreated();

	const onSendTestEmailCreated = useCallback(
		async (emailAddress: string) =>
			await sendEmail_Created({
				email: emailAddress,
				customMessage: mailTemplate.value,
				lang: LangCode.Default,
				hotelID: viewModel.hotelID,
			}),
		[mailTemplate.value, sendEmail_Created, viewModel.hotelID],
	);

	return {
		...useEmailTemplates({
			mailTemplate,
			hotelEmailAddress,
			onSetViewModel,
		}),

		onSendTestEmailCreated,
	};
};
